import React, {useEffect} from "react";
import {connect} from "react-redux";

import {modifyPageLayoutComponents} from "../PageLayout";
import PricingTopPanel from "./PricingTopPanel/PricingTopPanel";
// import PricingList from "./PricingList";
import PricingHeader from "./PricingHeader";
import PricingMain from "./PricingMain";
import PricingContext from "./PricingContext";
import PricingLoader from "./PricingComponents/PricingLoader";
import {setAllowPricingPopups} from "./pricingActions";


const Pricing = (props) => {

  const {routeParams, setAllowPricingPopups} = props;

  // const [pricingState, pricingStateDispatch] = useReducer(
  //   pricingContextReducer,
  //   {}
  // );

  useEffect(() => {
    setAllowPricingPopups(true)
    return () => {
      setAllowPricingPopups(false)
    }
  }, []);

  return (
    // <PricingContext.Provider value={{pricingState, pricingStateDispatch}}>
    <PricingContext.Provider value={{routeParams}}>
      <div className="pr color-textgray text-left height-100">
        <PricingTopPanel/>
        {/*<PricingList/>// not used for now, mb we will come back to it later */}
        {/*{routeParams && routeParams.paramsGroupName === "list" ? <PricingMain/> : <PricingList/>}*/}
        <PricingMain/>
        <PricingLoader/>
      </div>
    </PricingContext.Provider>
  )
};

const mapStateToProps = (store) => {
  return {
    language: store.dashboardState.language,
  };
};

const mapDispatchToProps = {
  setAllowPricingPopups,
};

export default modifyPageLayoutComponents({
  pageHeader: PricingHeader,
  content: connect(mapStateToProps, mapDispatchToProps)(Pricing),
  pageFooter: null,
});
